import React from 'react';

import { SVGPropsType } from 'src/types';

const Copy = (props: SVGPropsType) => {
    const { fill, onClick, style, className } = props;
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            onClick={onClick}
            style={style}
            className={className}
        >
            <g clipPath="url(#clip0_33922_19669)">
                <path
                    d="M16.667 6.66669H9.16699C7.75033 6.66669 6.66699 7.75002 6.66699 9.16669V16.6667C6.66699 18.0834 7.75033 19.1667 9.16699 19.1667H16.667C18.0837 19.1667 19.167 18.0834 19.167 16.6667V9.16669C19.167 7.75002 18.0837 6.66669 16.667 6.66669ZM17.5003 16.6667C17.5003 17.1667 17.167 17.5 16.667 17.5H9.16699C8.66699 17.5 8.33366 17.1667 8.33366 16.6667V9.16669C8.33366 8.66669 8.66699 8.33335 9.16699 8.33335H16.667C17.167 8.33335 17.5003 8.66669 17.5003 9.16669V16.6667Z"
                    fill={fill}
                />
                <path
                    d="M4.16634 11.6666H3.33301C3.08301 11.6666 2.91634 11.5833 2.74967 11.4166C2.58301 11.25 2.49967 11.0833 2.49967 10.8333V3.33331C2.49967 3.08331 2.58301 2.91665 2.74967 2.74998C2.91634 2.58331 3.08301 2.49998 3.33301 2.49998H10.833C11.083 2.49998 11.2497 2.58331 11.4163 2.74998C11.583 2.91665 11.6663 3.08331 11.6663 3.33331V4.16665C11.6663 4.66665 11.9997 4.99998 12.4997 4.99998C12.9997 4.99998 13.333 4.66665 13.333 4.16665V3.33331C13.333 2.66665 13.083 1.99998 12.583 1.58331C12.1663 1.08331 11.4997 0.833313 10.833 0.833313H3.33301C2.66634 0.833313 1.99967 1.08331 1.58301 1.58331C1.08301 1.99998 0.833008 2.66665 0.833008 3.33331V10.8333C0.833008 11.5 1.08301 12.1666 1.58301 12.5833C1.99967 13.0833 2.66634 13.3333 3.33301 13.3333H4.16634C4.66634 13.3333 4.99967 13 4.99967 12.5C4.99967 12 4.66634 11.6666 4.16634 11.6666Z"
                    fill={fill}
                />
            </g>
            <defs>
                <clipPath id="clip0_33922_19669">
                    <rect width="20" height="20" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};

export default Copy;
